/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsCalendarDay
 */
export interface AllShipmentsCalendarDay {
  /**
   *
   * @type {LocalDate}
   * @memberof AllShipmentsCalendarDay
   */
  day: LocalDate;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCalendarDay
   */
  quoted: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCalendarDay
   */
  booked: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCalendarDay
   */
  revenue: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCalendarDay
   */
  companies: number;
}

/**
 * Check if a given object implements the AllShipmentsCalendarDay interface.
 */
export function instanceOfAllShipmentsCalendarDay(
  value: object,
): value is AllShipmentsCalendarDay {
  if (!("day" in value) || value["day"] === undefined) return false;
  if (!("quoted" in value) || value["quoted"] === undefined) return false;
  if (!("booked" in value) || value["booked"] === undefined) return false;
  if (!("revenue" in value) || value["revenue"] === undefined) return false;
  if (!("companies" in value) || value["companies"] === undefined) return false;
  return true;
}

export function AllShipmentsCalendarDayFromJSON(
  json: any,
): AllShipmentsCalendarDay {
  return AllShipmentsCalendarDayFromJSONTyped(json, false);
}

export function AllShipmentsCalendarDayFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsCalendarDay {
  if (json == null) {
    return json;
  }
  return {
    day: json["day"],
    quoted: json["quoted"],
    booked: json["booked"],
    revenue: json["revenue"],
    companies: json["companies"],
  };
}

export function AllShipmentsCalendarDayToJSON(
  json: any,
): AllShipmentsCalendarDay {
  return AllShipmentsCalendarDayToJSONTyped(json, false);
}

export function AllShipmentsCalendarDayToJSONTyped(
  value?: AllShipmentsCalendarDay | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    day: value["day"],
    quoted: value["quoted"],
    booked: value["booked"],
    revenue: value["revenue"],
    companies: value["companies"],
  };
}
